// extracted by mini-css-extract-plugin
export default {"voucherTermsPopup":"Style_voucherTermsPopup__to54r","popupBody":"Style_popupBody__Ytd2v"};